import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionStyled } from './styled';
import { AccordionWrapperProps } from './types';

const AccordionWrapper = ({ title, children }: AccordionWrapperProps) => {
  return (
    <AccordionStyled defaultExpanded disableGutters elevation={0} square={false}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">{title}</Typography>
      </AccordionSummary>

      <AccordionDetails>{children}</AccordionDetails>
    </AccordionStyled>
  );
};

export default AccordionWrapper;
